import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import type { GroupedInclusionDraft } from "@/models/GroupedInclusionModel.ts";
import { Queries } from "@/queries/Queries.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { TextToast } from "@/uiKit/atoms/Toast.tsx";

export const DeleteCell: React.FC<CellContext<GroupedInclusionDraft, unknown>> = ({ row }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const deleteDraft = Queries.patientSync.useDeleteGroupedInclusionDraft();

  return (
    <Button
      variant="text"
      data-action="sync.ongoing-import.delete"
      startIcon={<Icons.exit className={styles.icon} />}
      onClick={() =>
        deleteDraft.mutate(row.original.id, {
          onSuccess: () => {
            TextToast.success(t("patientSync.ongoingInclusionTable.deleted"));
          },
          onError: () => {
            TextToast.error(t("errors.unknownError"));
          },
        })
      }
    />
  );
};

export const DeleteHeader: React.FC = () => <></>;

const makeStyles = () => ({
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
  }),
});
